"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timepicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var flatpickr_1 = __importDefault(require("flatpickr"));
var reactstrap_1 = require("reactstrap");
var icons_1 = require("../../../icons");
var Timepicker = function (_a) {
    var options = _a.options, _b = _a.placeholder, placeholder = _b === void 0 ? 'Select time' : _b, props = __rest(_a, ["options", "placeholder"]);
    var wrapper = react_1.default.useRef(null);
    var inputGroup = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        (0, flatpickr_1.default)(inputGroup === null || inputGroup === void 0 ? void 0 : inputGroup.current, __assign({ allowInput: false, enableTime: true, noCalendar: true, dateFormat: 'h:i K', wrap: true, appendTo: wrapper === null || wrapper === void 0 ? void 0 : wrapper.current }, options));
    }, [options]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: wrapper, className: "position-relative", "data-cy": "flatpickr-timepicker" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "input-group input-group-merge input-group-flatpickr", ref: inputGroup }, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Input, __assign({ className: "form-control-prepended", placeholder: placeholder, "data-input": true }, props)), (0, jsx_runtime_1.jsx)("div", __assign({ className: "input-group-prepend" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "input-group-text", "data-toggle": true }, { children: (0, jsx_runtime_1.jsx)(icons_1.Clock24, {}) })) }))] })) })));
};
exports.Timepicker = Timepicker;
